import { required, maxLength } from 'vuelidate/lib/validators';

const validations = {
  applianceAreaId: {
    required,
  },
  cleaningProductId: {
    required,
  },
  howToUseItem: {
    required,
    maxLength: maxLength(1000),
  },
  responsiblePerson: {
    required,
  },
};

export default validations;
